// extracted by mini-css-extract-plugin
export default {"-large":"NRNnxFoa3aMzr2kQVVbO","containerGap":"Ii3AyGEKGsICf0T2ilrx","profilePictureImage":"U6DvIqhdawKqxoj3xMXv","secondaryText":"fLD0FhdvaFIPgpQjFItv"};